<template>
  <BittsModal
    v-if="deleteOverrideModalVisible"
    class="c-delete-override-modal"
    title="Delete override?"
    description="This will delete the override set at the population level for this partner."
    primary-button-text="Delete"
    primary-button-type="danger"
    variant="confirm"
    :width="400"
    :use-mask-to-close="true"
    @action="onConfirmDelete"
    @closed="onCancel"
  />
</template>
<script setup>
import { BittsModal } from '@crossbeam/bitts';

import { useDataSharesStore, useFlashesStore } from '@/stores';

const props = defineProps({
  dataShareId: {
    type: Number,
    default: null,
  },
  deleteOverrideModalVisible: {
    type: Boolean,
    default: false,
  },
});
const emits = defineEmits(['modal-closed']);
const { removeAndDeleteDataShare, refreshDataSharesStore } =
  useDataSharesStore();
const { addErrorFlash, addSuccessFlash } = useFlashesStore();

async function onConfirmDelete() {
  try {
    await removeAndDeleteDataShare(props.dataShareId);
    await refreshDataSharesStore();
    addSuccessFlash({
      message: 'Override has successfully been deleted',
    });
    emits('modal-closed', props.dataShareId);
  } catch (err) {
    addErrorFlash({
      message: 'There was a problem deleting the override',
    });
    emits('modal-closed');
  }
}

function onCancel() {
  emits('modal-closed');
}
</script>
